module.exports = {
  QUOTE: 'quote', // A accepter
  ACCEPTED: 'accepted', // A valider
  VALIDATED: 'validated', // A payer
  PAID: 'paid', // A signer
  SIGNED: 'signed', // A sourcer
  PROVISIONED: 'provisioned', // A livrer
  SHIPPED: 'shipped', // en cours
  RELEASED: 'released', // En résiliation
  FRAUD: 'fraud', // Fraud
  ENDED: 'ended', // Résilié
  TERMINATED: 'terminated', // Terminé
  CANCELLED: 'cancelled',
  REFUSED: 'refused',
};
